import { ParentCategory } from 'lib/sanity/types';

const categoryOrderPreference = [
  'account-help',
  'payment-help',
  'plan-help',
  'app-help',
  'device-help',
  'safety-privacy',
];

export const sortCategoriesByRanking = (a: ParentCategory, b: ParentCategory) => {
  const previousRank = categoryOrderPreference.indexOf(a.slug);
  const currentRank = categoryOrderPreference.indexOf(b.slug);

  return previousRank - currentRank;
};
